module.exports = __webpack_public_path__ + "img/ico_4.4318bdbf.png";